import { message } from "antd";

const userService = {
  // Profil-Daten abrufen
  me: async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/me`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Fehler beim Laden der Profil-Daten.");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Fehler beim Abrufen der Profil-Daten:", error.message);
      return null;
    }
  },

  // Passwort ändern
  changePassword: async (newPassword) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/change-password`,
        {
          method: "POST", // oder PATCH/PUT, je nachdem, wie dein Backend konfiguriert ist
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ newPassword }),
        }
      );

      if (!response.ok) {
        throw new Error("Fehler beim Ändern des Passworts.");
      }

      const data = await response.json();
      message.success("Passwort erfolgreich geändert.");
      return data;
    } catch (error) {
      console.error("Error changing password:", error.message);
      message.error("Fehler beim Ändern des Passworts: " + error.message);
      throw error;
    }
  },

  // E-Mail ändern (neue E-Mail wird erst nach Bestätigung übernommen)
  changeEmail: async (newEmail) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/change-email`,
        {
          method: "POST", // oder PATCH/PUT, je nachdem, wie dein Backend konfiguriert ist
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ newEmail }),
        }
      );

      if (!response.ok) {
        throw new Error("Fehler beim Ändern der E-Mail.");
      }

      const data = await response.json();
      message.success(
        "Verifikations-E-Mail wurde an die neue Adresse gesendet. Bitte überprüfen Sie Ihren Posteingang."
      );
      return data;
    } catch (error) {
      console.error("Error changing email:", error.message);
      message.error("Fehler beim Ändern der E-Mail: " + error.message);
      throw error;
    }
  },

  // Profil aktualisieren (z. B. Bio und andere editierbare Felder)
  updateProfile: async (profileData) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/update-profile`,
        {
          method: "PUT", // oder PATCH, je nach deiner Backend-Implementierung
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify(profileData),
        }
      );

      if (!response.ok) {
        throw new Error("Fehler beim Aktualisieren des Profils.");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error updating profile:", error.message);
      throw error;
    }
  },
  deleteAccount: async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/deleteAccount`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Fehler beim Löschen des Kontos.");
      }

      message.success("Konto erfolgreich gelöscht.");
      return true;
    } catch (error) {
      console.error("Fehler beim Löschen des Kontos:", error.message);
      message.error("Fehler beim Löschen des Kontos: " + error.message);
      throw error;
    }
  },
  exportData: async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/exportData`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Fehler beim Exportieren der Daten.");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "meine-daten.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();

      message.success("Daten erfolgreich exportiert.");
    } catch (error) {
      console.error("Fehler beim Datenexport:", error.message);
      message.error("Fehler beim Exportieren der Daten: " + error.message);
      throw error;
    }
  },
};

export default userService;
